frappe.provide("aracwebshop.aracwebshop.wishlist");
var wishlist = aracwebshop.aracwebshop.wishlist;

frappe.provide("aracwebshop.aracwebshop.shopping_cart");
var shopping_cart = aracwebshop.aracwebshop.shopping_cart;
window.__EZ_WISHLIST_BAR_LOADED__ = window.__EZ_WISHLIST_BAR_LOADED__ || false;

$.extend(wishlist, {
  
	// new 1-19-26
freeze({ title = "Working…", message = "Please wait…", progress = 0 } = {}) {
  // only allow on wishlist or cart
  const p = window.location.pathname;
  if (p !== "/wishlist") return;

  // backdrop
  let $freeze = $("#freeze");
  if (!$freeze.length) {
    $freeze = $('<div id="freeze" class="modal-backdrop fade"></div>').appendTo("body");
    setTimeout(() => $freeze.addClass("show"), 1);
  } else {
    $freeze.addClass("show");
  }

  // progress box (create once)
  if (!document.getElementById("ez-freeze-box")) {
    const style = document.createElement("style");
    style.id = "ez-freeze-style";
    style.textContent = `
      #ez-freeze-box{
        position:fixed; left:50%; top:50%; transform:translate(-50%,-50%);
        z-index:100000; width:min(520px,92vw);
        background:#fff; border-radius:18px; padding:18px 18px 16px;
        box-shadow:0 18px 55px rgba(0,0,0,.25);
        font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial;
      }
      #ez-freeze-title{ font-weight:800; font-size:15px; margin-bottom:8px; }
      #ez-freeze-msg{ font-size:13px; opacity:.9; margin-bottom:12px; }
      #ez-freeze-bar{ width:100%; height:10px; background:#e5e7eb; border-radius:999px; overflow:hidden; }
      #ez-freeze-bar > div{ height:100%; width:0%; background:#0284c7; transition:width .15s ease; }
      :is(html.arac-dark, html[data-theme="dark"]) #ez-freeze-box{
        background:linear-gradient(180deg,#14181d 0%,#101316 100%);
        border:1px solid rgba(210,217,224,.22);
        color:#f8fafc;
        box-shadow:0 28px 80px rgba(0,0,0,.62);
      }
      :is(html.arac-dark, html[data-theme="dark"]) #ez-freeze-bar{ background:#222831; }
      :is(html.arac-dark, html[data-theme="dark"]) #ez-freeze-bar > div{ background:linear-gradient(135deg,#38bdf8,#2563eb); }
    `;
    document.head.appendChild(style);

    const box = document.createElement("div");
    box.id = "ez-freeze-box";
    box.innerHTML = `
      <div id="ez-freeze-title"></div>
      <div id="ez-freeze-msg"></div>
      <div id="ez-freeze-bar"><div></div></div>
    `;
    document.body.appendChild(box);
  }

  // initial state
  document.getElementById("ez-freeze-title").textContent = title;
  document.getElementById("ez-freeze-msg").textContent = message;
  document.querySelector("#ez-freeze-bar > div").style.width =
    `${Math.max(0, Math.min(100, progress))}%`;
},

set_freeze_progress({ current, total, message } = {}) {
  const fill = document.querySelector("#ez-freeze-bar > div");
  const msg = document.getElementById("ez-freeze-msg");
  if (!fill || !msg || !total) return;

  msg.textContent = message || `Processing ${current}/${total}…`;
  fill.style.width = `${Math.round((current / total) * 100)}%`;
},

unfreeze() {
  const box = document.getElementById("ez-freeze-box");
  if (box) box.remove();

  const style = document.getElementById("ez-freeze-style");
  if (style) style.remove();

  if ($('#freeze').length) {
    let freeze = $('#freeze').removeClass("show");
    setTimeout(() => freeze.remove(), 1);
  }
},

	 init_ez_wishlist_bar() {
    // ✅ Prevent double-init if wishlist.js is loaded twice
    if (window.__EZ_WISHLIST_BAR_LOADED__) return;
    window.__EZ_WISHLIST_BAR_LOADED__ = true;

    const WRAPPER_SELECTOR = "#page-wishlist";
    const METHOD_REMOVE_ONE = "aracwebshop.aracwebshop.doctype.wishlist.wishlist.remove_from_wishlist";

    const ADD_BTN_SELECTORS = [
      "button.add-to-cart",
      "button.btn-add-to-cart",
      "button[data-action='add-to-cart']",
      "a.add-to-cart",
      "a.btn-add-to-cart",
      "[onclick*='add_to_cart']",
    ];

    // ---------- UI (SVG) ----------
    const SVG_TRASH = `
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
        <path fill-rule="evenodd" d="M9 3a1 1 0 0 0-1 1v1H5.5a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2H16V4a1 1 0 0 0-1-1H9Zm1 2h4V4h-4v1Zm-3 4a1 1 0 0 1 1.075.922L8.9 20h6.2l.825-10.078a1 1 0 1 1 1.994.164l-.85 10.384A2 2 0 0 1 15.076 22H8.924a2 2 0 0 1-1.993-1.53L6.081 10.086A1 1 0 0 1 7 9Zm3.75 1.5a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm2.5 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Z" clip-rule="evenodd"/>
      </svg>
    `;
    const SVG_BAG = `
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
        <path fill-rule="evenodd" d="M14 7h-4v3a1 1 0 0 1-2 0V7H6a1 1 0 0 0-.997.923l-.917 11.924A2 2 0 0 0 6.08 22h11.84a2 2 0 0 0 1.994-2.153l-.917-11.924A1 1 0 0 0 18 7h-2v3a1 1 0 1 1-2 0V7Zm-2-3a2 2 0 0 0-2 2v1H8V6a4 4 0 0 1 8 0v1h-2V6a2 2 0 0 0-2-2Z" clip-rule="evenodd"/>
      </svg>
    `;

    // ---------- Styles ----------
    if (!document.getElementById("ez-wishlist-bar-style")) {
      const styleSheet = document.createElement("style");
      styleSheet.id = "ez-wishlist-bar-style";
      styleSheet.textContent = `
        @keyframes wishlistBarIn { from {opacity:0; transform: translateY(14px);} to {opacity:1; transform: translateY(0);} }
        ${WRAPPER_SELECTOR}{ position: relative; padding-bottom: 15px; }
        #wishlist-action-wrap{ position: sticky; bottom: 14px; z-index: 50; padding: 0 clamp(12px, 3vw, 24px); animation: wishlistBarIn .35s ease-out; }
        #wishlist-action-bar{ width: 100%; max-width: 980px; margin: 0 auto; padding: 12px; display: flex; align-items: center; justify-content: space-between; gap: 12px;
          border-radius: 20px; background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(16px) saturate(135%); -webkit-backdrop-filter: blur(16px) saturate(135%);
          border: 1px solid rgba(226, 232, 240, 0.9); box-shadow: 0 18px 50px rgba(15, 23, 42, 0.14);
        }
        .wishlist-action-left{ display:flex; align-items:center; gap:12px; min-width:0; }
        .wishlist-action-right{ display:flex; align-items:center; gap:12px; }
        .wishlist-btn{ border:0; border-radius:999px; min-height:46px; padding:0 18px; display:inline-flex; align-items:center; justify-content:center; gap:10px;
          font-weight:800; font-size:13px; cursor:pointer; user-select:none; transition: transform .15s ease, box-shadow .15s ease, opacity .15s ease, filter .15s ease;
        }
        .wishlist-btn:hover{ transform: translateY(-1px); }
        .wishlist-btn:active{ transform: translateY(0); }
        .wishlist-btn[disabled]{ opacity:.65; cursor:not-allowed; transform:none !important; box-shadow:none !important; }
        #wishlist-clear-all-btn{ color:#fff; background: linear-gradient(135deg,#dc2626 0%,#ef4444 100%); box-shadow:0 12px 28px rgba(220,38,38,.22); }
        #wishlist-add-all-btn{ color:#fff; background: linear-gradient(135deg,#0369a1 0%,#0284c7 100%); box-shadow:0 12px 28px rgba(2,132,199,.22); }
        :is(html.arac-dark, html[data-theme="dark"]) #wishlist-action-bar{
          background: linear-gradient(135deg, rgba(22, 26, 31, 0.94), rgba(10, 12, 15, 0.94));
          border-color: rgba(210, 217, 224, 0.22);
          box-shadow: 0 24px 60px rgba(0,0,0,.48), inset 0 1px 0 rgba(255,255,255,.05);
        }
        :is(html.arac-dark, html[data-theme="dark"]) #wishlist-clear-all-btn{
          background: linear-gradient(135deg,#ef4444 0%,#b91c1c 100%);
          box-shadow: 0 14px 32px rgba(239,68,68,.2);
        }
        :is(html.arac-dark, html[data-theme="dark"]) #wishlist-add-all-btn{
          background: linear-gradient(135deg,#38bdf8 0%,#0369a1 100%);
          box-shadow: 0 14px 32px rgba(56,189,248,.18);
        }
        @media (max-width:640px){
          ${WRAPPER_SELECTOR}{ padding-bottom: 20px; }
          #wishlist-action-wrap{ padding:0 14px; bottom:12px; }
          #wishlist-action-bar{ padding:10px; border-radius:18px; }
          .wishlist-btn{ width:100%; min-height:44px; padding:0 14px; font-size:12.5px; }
          .wishlist-action-left,.wishlist-action-right{ width:100%; }
        }
      `;
      document.head.appendChild(styleSheet);
    }

    // ---------- Helpers ----------
    const unique = (arr) => [...new Set(arr)];

    function getWishlistItemCodes(scopeEl) {
      const a = [...scopeEl.querySelectorAll("[data-item-code]")]
        .map((el) => el.getAttribute("data-item-code"))
        .filter(Boolean);
      if (a.length) return unique(a);

      const b = [...scopeEl.querySelectorAll("[onclick]")]
        .map((el) => {
          const s = el.getAttribute("onclick") || "";
          const m = s.match(/remove_from_wishlist\(['"](.+?)['"]\)/);
          return m ? m[1] : null;
        })
        .filter(Boolean);
      if (b.length) return unique(b);

      return [];
    }

    function getAddableWishlistItemCodes(scopeEl) {
      const a = [...scopeEl.querySelectorAll(".wishlist-card")]
        .filter((card) => card.querySelector(".btn-add-to-cart") !== null)
        .map((card) => card.querySelector(".btn-add-to-cart").getAttribute("data-item-code"))
        .filter(Boolean);
      return unique(a);
    }

    function callRemoveOne(item_code) {
      return new Promise((resolve, reject) => {
        frappe.call({
          method: METHOD_REMOVE_ONE,
          args: { item_code },
          freeze: false,
          callback: () => resolve(),
          error: (e) => reject(e),
        });
      });
    }

    // ✅ IMPORTANT: sequential click to avoid Quotation deadlock
    // async function clickAddToCartButtonsSequential(scopeEl) {
    //   const btns = ADD_BTN_SELECTORS
    //     .flatMap((sel) => [...scopeEl.querySelectorAll(sel)])
    //     .filter((el) => !!el && !el.disabled);

    //   if (!btns.length) return false;

    //   for (let i = 0; i < btns.length; i++) {
    //     try { btns[i].click(); } catch (e) {}
    //     await new Promise((r) => setTimeout(r, 400)); // delay avoids deadlock
    //   }
    //   return true;
    // }

    async function clearAll(btn, container, refresh, setIdleLabels) {
      const codes = getWishlistItemCodes(container);
      if (!codes.length) return refresh();

      const ok = confirm(`Clear (${codes.length}) items from wishlist?`);
      if (!ok) return;

      btn.disabled = true;
      try {
        const other = document.getElementById("wishlist-add-all-btn");
        if (other) other.disabled = true;

        for (let i = 0; i < codes.length; i++) {
          btn.innerHTML = `${SVG_TRASH}<span>Clearing ${i + 1}/${codes.length}</span>`;
          await callRemoveOne(codes[i]);
        }
        window.location.reload();
      } catch (err) {
        console.error("[WISHLIST] Clear all failed:", err);
        try { frappe.msgprint("Failed to clear wishlist. Check console."); } catch (e) {}
        btn.disabled = false;
        const other = document.getElementById("wishlist-add-all-btn");
        if (other) other.disabled = false;
        setIdleLabels();
        refresh();
      }
    }
 
async function addAllToCart(btn, container, refresh, setIdleLabels) {
  const codes = getAddableWishlistItemCodes(container);
  if (!codes.length) return refresh();

  const ok = confirm(`Add (${codes.length}) items to cart?`);
  if (!ok) return;

  btn.disabled = true;
  const other = document.getElementById("wishlist-clear-all-btn");
  if (other) other.disabled = true;

  // ✅ Freeze ONCE + show progress bar
  wishlist.freeze({
    title: "Adding items to cart…",
    message: `Starting 0/${codes.length}…`,
    progress: 0
  });

  try {
    for (let i = 0; i < codes.length; i++) {
      const item_code = codes[i];
      const { uom, conversion_factor } = wishlist.get_wishlist_uom(item_code);

      // ✅ Update progress (no re-freeze)
      wishlist.set_freeze_progress({
        current: i + 1,
        total: codes.length,
        message: `Adding ${i + 1}/${codes.length}…`
      });

      // ✅ Add to cart (WAIT until finished)
      const r = await new Promise((resolve) => {
        shopping_cart.shopping_cart_update({
          item_code,
          qty: 1,
          uom: uom || null,
          conversion_factor: conversion_factor || null,
          cart_dropdown: true,
          callback: (resp) => resolve(resp),
        });
      });

      if (r?.exc) {
        throw new Error(`Add to cart failed for ${item_code}`);
      }

      // ✅ Remove from wishlist AFTER successful add
      await callRemoveOne(item_code);
    }

    window.location.reload();
  } catch (err) {
    console.error("[WISHLIST] Add all failed:", err);
    try {
      frappe.msgprint({
        title: __("Error"),
        message: __("Failed while adding all items. Please check console."),
        indicator: "red",
      });
    } catch (e) {}

    btn.disabled = false;
    if (other) other.disabled = false;
    setIdleLabels();
    refresh();
  } finally {
    // ✅ ALWAYS remove overlay even on error
    wishlist.unfreeze();
  }
}



    // ---------- Mount bar (retry because wishlist renders late) ----------
    let tries = 0;
    const maxTries = 30;

    const timer = setInterval(() => {
      tries++;

      const container = document.querySelector(WRAPPER_SELECTOR);
      if (!container) {
        if (tries >= maxTries) clearInterval(timer);
        return;
      }

      if (document.getElementById("wishlist-action-wrap")) {
        clearInterval(timer);
        return;
      }

      const wrap = document.createElement("div");
      wrap.id = "wishlist-action-wrap";

      const bar = document.createElement("div");
      bar.id = "wishlist-action-bar";
      bar.innerHTML = `
        <div class="wishlist-action-left">
          <button class="wishlist-btn" id="wishlist-clear-all-btn" type="button"></button>
        </div>
        <div class="wishlist-action-right">
          <button class="wishlist-btn" id="wishlist-add-all-btn" type="button"></button>
        </div>
      `;

      wrap.appendChild(bar);
      container.appendChild(wrap);

      const btnClear = bar.querySelector("#wishlist-clear-all-btn");
      const btnAddAll = bar.querySelector("#wishlist-add-all-btn");

      const setIdleLabels = () => {
        const total = getWishlistItemCodes(container).length;
        const addable = getAddableWishlistItemCodes(container).length;
        btnClear.innerHTML = `${SVG_TRASH}<span>Clear (${total}) items</span>`;
        btnAddAll.innerHTML = `${SVG_BAG}<span>Add (${addable}) items</span>`;
        if (addable === 0) {
          btnAddAll.disabled = true;
          btnAddAll.style.opacity = "0.5";
          btnAddAll.style.cursor = "not-allowed";
        } else {
          btnAddAll.disabled = false;
          btnAddAll.style.opacity = "1";
          btnAddAll.style.cursor = "pointer";
        }
      };

      const refresh = () => {
        const codes = getWishlistItemCodes(container);
        wrap.style.display = codes.length ? "block" : "none";
        if (!btnClear.disabled && !btnAddAll.disabled) setIdleLabels();
      };

      btnClear.addEventListener("click", () => clearAll(btnClear, container, refresh, setIdleLabels));
      btnAddAll.addEventListener("click", () => addAllToCart(btnAddAll, container, refresh, setIdleLabels));

      refresh();
      setTimeout(refresh, 900);

      clearInterval(timer);
    }, 200);
  },
  load_wishlist_uoms() {
    return new Promise((resolve) => {
      frappe.call({
        method: "aracwebshop.aracwebshop.api.get_wishlist_uoms",
        callback(r) {
          window.__WISHLIST_UOMS__ = {};
          (r.message || []).forEach(row => {
            window.__WISHLIST_UOMS__[row.item_code] = {
              uom: row.custom_uom || null,
              conversion_factor: row.conversion_factor || null,
            };
          });
          resolve(window.__WISHLIST_UOMS__);
        }
      });
    });
  },

  get_wishlist_uom(item_code) {
    return (window.__WISHLIST_UOMS__ && window.__WISHLIST_UOMS__[item_code]) || { uom: null, conversion_factor: null };
  },


// end new 1-19-26
	set_wishlist_count: function(animate=false) {
		// set badge count for wishlist icon
		var wish_count = frappe.get_cookie("wish_count");
		if (frappe.session.user==="Guest") {
			wish_count = 0;
		}
		const next_count = parseInt(wish_count || 0, 10) || 0;

		var $wishlist = $('.wishlist-icon');
		var $badge = $('.wishlist-icon [id="wish-count"], #wish-count-mobile');
		$badge.attr({ role: "status", "aria-live": "polite", "aria-atomic": "true" });
		const previous_count = parseInt($badge.first().text() || 0, 10) || 0;
		const count_direction = next_count < previous_count ? "down" : "up";

		if (frappe.session.user === "Guest" || (typeof window.arac_wishlist_enabled !== 'undefined' && !window.arac_wishlist_enabled)) {
			$wishlist.addClass('hidden');
		} else {
			$wishlist.removeClass('hidden');
		}

		if (next_count > 0) {
			$badge.text(next_count).removeClass('hidden');
			if (animate) {
				shopping_cart.animate_count_change($badge, count_direction);
			}
		} else {
			if (animate && previous_count > 0) {
				$badge.text('0').removeClass('hidden');
				shopping_cart.animate_count_change($badge, "down", () => {
					$badge.addClass('hidden');
				});
			} else {
				$badge.removeClass("animate-count-up animate-count-down").addClass('hidden').text('0');
			}
		}
	},

	bind_move_to_cart_action: function() {
		// move item to cart from wishlist
		let me = this;
		$('.page_content').off("click.wishlist_move_to_cart", ".btn-add-to-cart")
			.on("click.wishlist_move_to_cart", ".btn-add-to-cart", (e) => {
			const $move_to_cart_btn = $(e.currentTarget);
			$move_to_cart_btn.prop("disabled", true);
			let item_code = $move_to_cart_btn.data("item-code");
			const { uom, conversion_factor } = wishlist.get_wishlist_uom(item_code);

			shopping_cart.shopping_cart_update({
				item_code,
				qty: 1,
				uom: uom,
				cart_dropdown: true,
				callback: function(r) {
					let res = r.message || {};
					if (r.exc || res.status === "error") {
						$move_to_cart_btn.prop("disabled", false);
						return;
					}

					let success_action = function() {
						const $card_wrapper = $move_to_cart_btn.closest(".wishlist-card");
						$card_wrapper.css("transition", "all 0.3s ease");
						$card_wrapper.css({ opacity: 0, transform: "scale(0.9)" });
						setTimeout(() => {
							$card_wrapper.remove();
							if (frappe.get_cookie("wish_count") == 0 || $(".wishlist-card:visible").length === 0) {
								me.render_empty_state();
							}
						}, 300);
					};
					let failure_action = function() {
						$move_to_cart_btn.prop("disabled", false);
					};
					let args = { item_code: item_code };
					me.add_remove_from_wishlist("remove", args, success_action, failure_action, true);
				}
			});
		});
	},

	bind_remove_action: function() {
		// remove item from wishlist
		let me = this;

		$('.page_content').off("click.wishlist_remove", ".remove-wish")
			.on("click.wishlist_remove", ".remove-wish", (e) => {
			const $remove_wish_btn = $(e.currentTarget);
			$remove_wish_btn.prop("disabled", true);
			let item_code = $remove_wish_btn.data("item-code");

			let success_action = function() {
				const $card_wrapper = $remove_wish_btn.closest(".wishlist-card");
				$card_wrapper.css("transition", "all 0.3s ease");
				$card_wrapper.css({ opacity: 0, transform: "scale(0.9)" });
				setTimeout(() => {
					$card_wrapper.remove();
					if (frappe.get_cookie("wish_count") == 0 || $(".wishlist-card:visible").length === 0) {
						me.render_empty_state();
					}
				}, 300);
			};
			let failure_action = function() {
				$remove_wish_btn.prop("disabled", false);
			};
			let args = { item_code: item_code };
			this.add_remove_from_wishlist("remove", args, success_action, failure_action);
		});
	},

	bind_wishlist_action() {
		// 'wish'('like') or 'unwish' item in product listing
		$('.page_content').off('click.wishlist_toggle', '.like-action, .like-action-list')
			.on('click.wishlist_toggle', '.like-action, .like-action-list', (e) => {
			const $btn = $(e.currentTarget);
			this.wishlist_action($btn);
		});
	},

	wishlist_action(btn) {
		const $wish_icon = btn.find('.wish-icon');
		let me = this;
			
		if (frappe.session.user==="Guest") {
			if (localStorage) {
				localStorage.setItem("last_visited", window.location.pathname);
			}
			this.redirect_guest();
			return;
		}

		let success_action = function() {
			aracwebshop.aracwebshop.wishlist.set_wishlist_count(true);
		};

		const all_color_classes = 'stroke-slate-400 fill-none group-hover/wish:stroke-red-500 not-wished fill-red-500 stroke-red-500 wished';

		// Retrieve UOM safely with try-catch
		let uom = null;
		try {
			const uom_info = get_selected_uom_for_item(btn);
			uom = uom_info ? uom_info.uom : null;
		} catch (err) {
			console.error("[WISHLIST] Error getting UOM:", err);
		}

		if ($wish_icon.hasClass('wished')) {
			// un-wish item
			btn.removeClass("like-animate");
			btn.removeClass("like-action-wished");
			
			// Toggle color classes on the SVG icon
			$wish_icon.removeClass(all_color_classes)
			          .addClass('stroke-slate-400 fill-none group-hover/wish:stroke-red-500 not-wished');

			let args = { item_code: btn.data('item-code') };
			let failure_action = function() {
				btn.addClass("like-action-wished");
				$wish_icon.removeClass(all_color_classes)
				          .addClass('fill-red-500 stroke-red-500 wished');
			};
			this.add_remove_from_wishlist("remove", args, success_action, failure_action);
		} else {
			// wish item
			btn.removeClass("like-animate");
			void btn[0].offsetWidth; // trigger reflow
			btn.addClass("like-animate");
			btn.addClass("like-action-wished");

			// Trigger spring heart pop animation on the SVG
			$wish_icon.removeClass("like-animate-heart");
			void $wish_icon[0].offsetWidth; // trigger reflow
			$wish_icon.addClass("like-animate-heart");
			
			// Toggle color classes on the SVG icon
			$wish_icon.removeClass(all_color_classes)
			          .addClass('fill-red-500 stroke-red-500 wished');
			
			let args = { item_code: btn.data('item-code'), uom: uom || null };
			let failure_action = function() {
				btn.removeClass("like-animate");
				btn.removeClass("like-action-wished");
				$wish_icon.removeClass("like-animate-heart");
				$wish_icon.removeClass(all_color_classes)
				          .addClass('stroke-slate-400 fill-none group-hover/wish:stroke-red-500 not-wished');
			};
			this.add_remove_from_wishlist("add", args, success_action, failure_action);
		}
	},

	toggle_button_class(button, remove, add) {
		button.removeClass(remove);
		button.addClass(add);
	},

	add_remove_from_wishlist(action, args, success_action, failure_action, async=false) {
		/*	AJAX call to add or remove Item from Wishlist
			action: "add" or "remove"
			args: args for method (item_code, price, formatted_price),
			success_action: method to execute on successs,
			failure_action: method to execute on failure,
			async: make call asynchronously (true/false).	*/
		if (frappe.session.user==="Guest") {
			if (localStorage) {
				localStorage.setItem("last_visited", window.location.pathname);
			}
			this.redirect_guest();
		} else {
			let method = "aracwebshop.aracwebshop.doctype.wishlist.wishlist.add_to_wishlist";
			if (action === "remove") {
				method = "aracwebshop.aracwebshop.doctype.wishlist.wishlist.remove_from_wishlist";
			}

			frappe.call({
				async: async,
				type: "POST",
				method: method,
				args: args,
				callback: function (r) {
					if (r.exc) {
						if (failure_action && (typeof failure_action === 'function')) {
							failure_action();
						}
						frappe.msgprint({
							message: __("Sorry, something went wrong. Please refresh."),
							indicator: "red", title: __("Note")
						});
					} else if (success_action && (typeof success_action === 'function')) {
						success_action();
					}
				}
			});
		}
	},

	redirect_guest() {
		frappe.call('aracwebshop.aracwebshop.api.get_guest_redirect_on_action').then((res) => {
			window.location.href = res.message || "/login";
		});
	},

	render_empty_state() {
		const $container = $("#page-wishlist").length ? $("#page-wishlist") : $(".page_content");
		$container.html(`
			<div class="max-w-md mx-auto py-16 text-center">
				<div class="w-48 h-48 mx-auto mb-6 bg-slate-50 rounded-full flex items-center justify-center border border-slate-100">
					<svg class="w-24 h-24 text-slate-300" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"/>
					</svg>
				</div>
				<h2 class="text-xl font-extrabold text-slate-900 mb-2">${ __("Your wishlist is empty") }</h2>
				<p class="text-sm text-slate-500 mb-6 leading-relaxed">${ __("Explore items and save them to your wishlist to buy later.") }</p>
				<a class="inline-flex items-center justify-center px-6 py-3 bg-theme-primary hover:bg-theme-primary-hover text-white font-bold text-sm rounded-xl shadow-lg shadow-theme-primary/10 transition-all cursor-pointer" href="/all-products">
					${ __("Explore Products") }
				</a>
			</div>
		`);
	}

});

function get_selected_uom_for_item($btn) {
  try {
    const $wrap = $btn.closest(
      '.item-cart, .product-details, .item-card, .basem'
    );
    if (!$wrap.length) return { uom: null, conversion_factor: null };

    // 1️⃣ Product page → UOM buttons
    const $activeBtn = $wrap.find('.uom-btn.active');
    if ($activeBtn.length) {
      return {
        uom: $activeBtn.data('uom'),
        conversion_factor: $activeBtn.data('conversion')
      };
    }

    // 2️⃣ Grid → dropdown select
    const item_code = $btn.data('item-code');
    let $select = $();
    if (item_code) {
      try {
        const escaped_code = CSS.escape(item_code);
        $select = $wrap.find(`.uom-select[data-item-code="${escaped_code}"], .uom-select`);
      } catch (e) {
        $select = $wrap.find('.uom-select');
      }
    } else {
      $select = $wrap.find('.uom-select');
    }

    if ($select.length) {
      const $opt = $select.find('option:selected');
      return {
        uom: $opt.val(),
        conversion_factor: $opt.data('conversion')
      };
    }

    // 3️⃣ Single UOM → hidden input
    const $hidden = $wrap.find('#selected-uom, .selected-uom');
    if ($hidden.length) {
      return {
        uom: $hidden.val(),
        conversion_factor: $hidden.data('conversion')
      };
    }

    // 4️⃣ Fallback → display text
    const $display = $wrap.find('.uom-display');
    if ($display.length) {
      return {
        uom: $display.text().trim(),
        conversion_factor: 1
      };
    }
  } catch (err) {
    console.error("[WISHLIST] Error in get_selected_uom_for_item:", err);
  }

  return { uom: null, conversion_factor: null };
}
frappe.ready(function() {
	if (typeof window.arac_wishlist_enabled !== 'undefined' && !window.arac_wishlist_enabled) {
		$(".wishlist, .wishlist-icon, .like-action, .like-action-list").addClass('hidden').hide();
		if (window.location.pathname === "/wishlist") {
			window.location.href = "/";
		}
		return;
	}

	// Bind wishlist toggle clicks globally so it functions on all pages (home, campaigns, list, etc.)
	wishlist.bind_wishlist_action();

	if (window.location.pathname !== "/wishlist") {
		$(".wishlist").removeClass('hidden');
		wishlist.set_wishlist_count();
	} else {
		wishlist.load_wishlist_uoms().then(() => {
			wishlist.bind_move_to_cart_action();
			wishlist.bind_remove_action();
			wishlist.init_ez_wishlist_bar();
		});
	}
});
